export type MobileColumnTab = 'spread' | 'teamTotal';

export function getMobileMarketVisibilityClass(
    index: number,
    mobileColumnTab: MobileColumnTab,
    showMoneylineSlot: boolean
): string {
    if (mobileColumnTab === 'teamTotal') {
        return index === 3 ? '' : 'd-none';
    }

    if (index === 0) return showMoneylineSlot ? 'd-none' : '';
    if (index === 1) return showMoneylineSlot ? '' : 'd-none';
    if (index === 2) return '';
    return 'd-none';
}
